import { AvvirEvent } from "type_aliases";

export type CapturedTradeCostsMaterializedViewRefreshedEvent = AvvirEvent<typeof CAPTURED_TRADE_COSTS_MATERIALIZED_VIEW_REFRESHED, { message: string; }>;

const capturedTradeCostsMaterializedViewRefreshed = (message: string): CapturedTradeCostsMaterializedViewRefreshedEvent => ({
  type: CAPTURED_TRADE_COSTS_MATERIALIZED_VIEW_REFRESHED,
  payload: {message},
});

export const CAPTURED_TRADE_COSTS_MATERIALIZED_VIEW_REFRESHED = "captured_trade_costs_materialized_view_refreshed";

export default capturedTradeCostsMaterializedViewRefreshed;
